import React from 'react';
import { IProps } from '@/elements/Text/Text.interface';
import { clsx } from 'clsx';
import { cleanHTML } from '@/utils/sanitizeHTML'; // Import the utility function
import '@/elements/Text/Text.styles.css';

const Text: React.FC<IProps> = (props) => {
    const { as: Component = 'div', children, html, className } = props;

    const combinedClassName = clsx('textElement', className);

    if (html) {
        return (
            <Component
                className={combinedClassName}
                dangerouslySetInnerHTML={{ __html: cleanHTML(html as string) }} // Use the sanitized HTML
            />
        );
    }

    return <Component className={combinedClassName}>{children}</Component>;
};

export default Text;
